import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'

import { ChecklistItem } from 'src/analytics'
import { JourneyActionStatusEnum } from 'src/api/main'
import {
  mfaConfigPartialUpdateMutation,
  mfaConfigRetrieveOptions,
  mfaConfigRetrieveQueryKey
} from 'src/api/main/@tanstack/react-query.gen'
import { useReportJourneyStep } from 'src/features/workspaces/onboarding'
import { useShowApiErrors } from 'src/utils'

export const useMfaSettings = () => {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const showApiErrors = useShowApiErrors()
  const queryClient = useQueryClient()
  const reportStep = useReportJourneyStep()

  const mfaQuery = useQuery(mfaConfigRetrieveOptions())

  const mfaMutation = useMutation({
    ...mfaConfigPartialUpdateMutation(),
    onSuccess: async (_data, variables) => {
      message.success(t('account.messages.settingsSaved'))
      reportStep(ChecklistItem.SECURITY, {
        status: variables.body?.enabled
          ? JourneyActionStatusEnum.DONE
          : JourneyActionStatusEnum.TODO
      })
      await queryClient.invalidateQueries({
        queryKey: mfaConfigRetrieveQueryKey()
      })
    },
    onError: (error) => showApiErrors(error)
  })

  return {
    handleToggle: (checked: boolean) => {
      mfaMutation.mutate({ body: { enabled: checked } })
    },
    hasError: mfaQuery.isError,
    isLoading: mfaQuery.isLoading,
    isPending: mfaMutation.isPending,
    mfaConfig: mfaQuery.data,
    refetch: () => {
      void mfaQuery.refetch()
    }
  }
}
